import { format } from 'date-fns';

type DateAxisTickProps = {
  x?: number;
  y?: number;
  index?: number;
  visibleTicksCount?: number;
  payload?: { value: number };
};

const DateAxisTick = ({
  x,
  y,
  index,
  visibleTicksCount,
  payload,
}: DateAxisTickProps) => {
  if (x === undefined || y === undefined || payload?.value === undefined)
    return <></>;
  const textAnchor =
    index === 0
      ? 'start'
      : index === (visibleTicksCount ?? 0) - 1
        ? 'end'
        : 'middle';
  return (
    <text
      x={x}
      y={y}
      dy={16}
      textAnchor={textAnchor}
      fill='var(--warm-grey-300)'
    >
      {format(new Date(payload.value), "MMM ''yy")}
    </text>
  );
};

export default DateAxisTick;
